{"messages":{"previous":"Zurück","next":"Weiter","today":"Heute","month":"Monat","week":"Woche","list":"Liste","day":"Tag"}}